import { connect } from 'react-redux';

import { selectors } from '../../dux/user';
import Authorized from './Authorized';

const mapStateToProps = (state) => ({
  userPermissions: selectors.getIdentityState(state).permissions,
  userRoles: selectors.getIdentityState(state).roles,
});

export default connect(mapStateToProps, {})(Authorized);
